
//components
import LineTime from "../tramites/components/LineTime.vue"
import DialogFileList from "./DialogFileList.vue"
import DialogRectify from "../tramites/DialogRectify.vue"

import {
    defineComponent,
    onMounted,
    ref,
    provide
} from "vue";
import { useRouter } from "vue-router";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";

//services
import Master from "@/core/services/MasterService";
import Tramite from "@/core/services/TramiteService";
import {errManager } from "@/core/config/Tools";

export default defineComponent({
    name: "ExpedienteList",
    components:{
        LineTime, DialogFileList, DialogRectify
    },
    setup() {
        const formSearch = ref({
            nro_proceedings: "",
            mstatus: "",
        });

        const router = useRouter();
        const listStatusDocs = ref < any[] > ([]);
        const listExpedients = ref < any[] > ([]);
        const listHistory = ref < any[] > ([]);
        const loading = ref(false);
        const fullscreenLoading = ref(false);
        const dialogHistory = ref(false);
        const open_dialog_file_list = ref(false);
        const expediente = ref({});
        const open_dialog_rectify = ref(false);

        provide('listHistory', listHistory)
        provide('open_dialog_file_list', open_dialog_file_list);
        provide('open_dialog_rectify', open_dialog_rectify);

        const newTramite = () => {
            router.push({
                name: "ExpedienteNew",
            });
        };

        const onSearch = () => {
            getListExpedients();
        };

        const getListStatusDocs = async () => {
            await Master.Details("api", "status-docs")
                .then((res) => {
                    listStatusDocs.value = res.data;
                })
                .catch(({response}) => {
                    errManager(response);
                });
        };

        const getListExpedients = async () => {
            loading.value = true;
            await Tramite.List(formSearch.value)
                .then((res) => {
                    listExpedients.value = res.data;
                    loading.value = false;
                })
                .catch(({response}) => {
                    loading.value = false;
                    errManager(response);
                });
        };

        const getListHistory = async (id) => {
            fullscreenLoading.value = true;
            await Tramite.History(id)
                .then((res) => {
                    listHistory.value = res.data;
                    fullscreenLoading.value = false;
                    dialogHistory.value = true;
                })
                .catch(({response}) => {
                    fullscreenLoading.value = false;
                    errManager(response);
                });
        };

        const onDialogFileList = (item) => {
            expediente.value = item
            open_dialog_file_list.value = true
        }

        const onDialogRectify = (item) => {
            expediente.value = item
            open_dialog_rectify.value = true
        }

        const resDialogRectify = (data) => {
            open_dialog_rectify.value = false
            if(data.status == "success")
                getListExpedients()
        }

        onMounted(() => {
            setCurrentPageBreadcrumbs("Overview", ["Account"]);
            getListStatusDocs();
            getListExpedients();
        });

        return {
            formSearch,
            listStatusDocs,
            listExpedients,
            newTramite,
            getListExpedients,
            onSearch,
            loading,
            listHistory,
            getListHistory,
            fullscreenLoading,
            dialogHistory,
            open_dialog_file_list,
            expediente,
            onDialogFileList,
            open_dialog_rectify,
            onDialogRectify,
            resDialogRectify
        };
    },
});
